export const colorCssVariables = [
  '--primary',
  '--primary-80',
  '--primary-50',
  '--primary-30',
  '--danger',
  '--danger-80',
  '--danger-50',
  '--danger-30',
  '--warning',
  '--warning-80',
  '--warning-50',
  '--black',
  '--white',
  '--smoke',
  '--whisper',
  '--text-color',
  '--bg-color',
  '--scrollbar-color',
] as const

export type TColor = (typeof colorCssVariables)[number]
type TThemeColorMap = Record<TColor, string>

const defaultTheme: TThemeColorMap = {
  '--primary': '#00b368',
  '--primary-80': '#00b36880',
  '--primary-50': '#00b36850',
  '--primary-30': '#00b36830',
  '--danger': '#f53d3d',
  '--danger-80': '#f53d3d80',
  '--danger-50': '#f53d3d50',
  '--danger-30': '#f53d3d30',
  '--warning': '#f49d25',
  '--warning-80': '#f49d2580',
  '--warning-50': '#f49d2550',
  '--black': '#000000',
  '--white': '#ffffff',
  '--smoke': '#f7f7f7',
  '--whisper': '#ededed',
  '--text-color': '#000000',
  '--bg-color': '#f7f7f7',
  '--scrollbar-color': '#b4b4bb',
}

export type TTheme = 'light'
export const themes: { [key in TTheme]: TThemeColorMap } = {
  light: defaultTheme,
}
